import React, { useMemo, useState } from 'react';
import { SearchIcon } from 'lucide-react';
import type { FieldRole } from '../../types/config';
import type { FieldScreen } from '../../types/navigation';
import { useStore } from '../../contexts/StoreContext';
import { MobileHeader } from '../../components/mobile/MobileHeader';
import { CaseMiniCard } from '../../components/mobile/CaseMiniCard';
import { bn } from '../../utils/bn';
const FILTERS = [{
  id: 'all',
  label: 'সব'
}, {
  id: 'registered',
  label: 'পিকআপ অপেক্ষমাণ'
}, {
  id: 'in_transit',
  label: 'পরিবহনাধীন'
}, {
  id: 'at_station',
  label: 'স্টেশনে'
}, {
  id: 'released',
  label: 'অবমুক্ত'
}];
export function FieldRecords({
  role,
  go
}: {
  role: FieldRole;
  go: (s: FieldScreen) => void;
}) {
  const {
    cases
  } = useStore();
  const stationRole = role === 'receiving' || role === 'release';
  const [filter, setFilter] = useState(stationRole ? 'at_station' : 'all');
  const [q, setQ] = useState('');
  const list = useMemo(() => {
    const term = q.trim().toLowerCase();
    return cases.filter(c => stationRole ? c.station?.station === 'তেজগাঁও ডাম্পিং স্টেশন' || c.stage === 'in_transit' : true).filter(c => filter === 'all' || c.stage === filter).filter(c => !term || [c.pcr, c.regNo, c.ownerName, c.barcode.serial ?? ''].some(v => v.toLowerCase().includes(term))).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }, [cases, filter, q, stationRole]);
  return <>
      <MobileHeader appName="ডিএমপি যানবাহন হেফাজত" title={stationRole ? 'স্টেশন ইনভেন্টরি — তেজগাঁও' : 'হেফাজত রেকর্ড ও অনুসন্ধান'} onBack={() => go({
      name: 'home'
    })} data-id="element-2113" data-mp="1yqlyqzc2dnh8" />
      <div className="shrink-0 space-y-2 border-b border-line bg-white px-4 py-3" data-id="element-2114" data-mp="1pqffsxxljvao">
        <div className="relative" data-id="element-2115" data-mp="1ksdyoijqe61u">
          <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft" data-id="element-2116" data-mp="1kvjmlugmj1vz" />
          <input className="input pl-9" placeholder="PCR, রেজিস্ট্রেশন, মালিক বা স্টিকার নম্বর" value={q} onChange={e => setQ(e.target.value)} aria-label="অনুসন্ধান" data-id="element-2117" data-mp="eaqt87o98yae" />
        </div>
        <div className="flex gap-1.5 overflow-x-auto no-scrollbar" data-id="element-2118" data-mp="avyzc1f2sqqb">
          {FILTERS.map(f => <button key={f.id} onClick={() => setFilter(f.id)} className={`shrink-0 rounded-full border px-3 py-1 text-xs font-semibold ${filter === f.id ? 'border-navy bg-navy text-white' : 'border-line bg-white text-ink-muted'}`} data-id="element-2119" data-mp="fs69y7if2qel">{f.label}</button>)}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto no-scrollbar px-4 py-3 space-y-2" data-id="element-2120" data-mp="3o8j07fs8vjyl">
        <p className="text-xs text-ink-muted" data-id="element-2121" data-mp="3t1u3x81rfkma">{bn(list.length)}টি রেকর্ড</p>
        {list.length === 0 && <p className="py-10 text-center text-sm text-ink-muted" data-id="element-2122" data-mp="3fafeojh9en6s">কোনো রেকর্ড পাওয়া যায়নি।</p>}
        {list.map(c => <CaseMiniCard key={c.pcr} c={c} onClick={() => go({
        name: 'case',
        pcr: c.pcr
      })} extra={stationRole && c.station ? <span className="text-[11px] font-semibold text-navy" data-id="element-2124" data-mp="3aab5leiokuql">স্লট {c.station.slot}</span> : undefined} data-id="element-2123" data-mp="3jb90n7b55rx1" />)}
      </div>
    </>;
}